import { DINEIN, DELIVERY, PICKUP, TABLE } from "../../../constants"

export const CHARGE_TYPE = {
    DELIVERY: "DELIVERY",
    OTHER: "OTHER"
}

export const DELIVERY_CHARGES_FIELDS = {
    MIN: "minDistance",
    MAX: "maxDistance",
    PRICE: "price",
}

export const GENERAL_CHARGES_FIELDS = {
    NAME: "name",
    VALUE: "value",
    PERCENTAGE: "isPercentage",
    ACTIVE: "isActive",
    ORDER_TYPE: "orderType",
    CUSTOMER_VISIBLE_MESSAGE: "customerVisibleMessage",
}

export const ORDER_TYPE_OPTIONS = [
    { label: "Dine In", value: DINEIN },
    { label: "Delivery", value: DELIVERY },
    { label: "Pick Up", value: PICKUP },
    { label: "Table", value: TABLE }
]

export const getKeyStart = (type, index) => `${type}_${index}`;
export const getItemKey = (index, field, type) => `${type}_${index}_${field}`;